const CLAIMS = {
    Admin: 'Admin',
    AdminViewOnly: 'AdminViewOnly',
}

export default CLAIMS
